const axios = require('axios');
// import router from "@/router";
import firebase from 'firebase/app';

import { getBaseUrls } from '@/utils/getBaseUrls';

// import * as sweetalert from "sweetalert";
import useLogout from '@/composables/useLogout';
import moment from 'moment';

import store from '@/store';

const { 
  baseURL, 
  inboxBaseURL, 
  aiSearchBaseURL, 
  integrationBaseURL, 
  teamsBaseURL, 
  aiBaseURL, 
  logEventsBaseURL, 
  reportsBaseURL, 
  activityBaseURL, 
  articlesBaseURL, 
  adminBaseURL, 
  userFlowBaseURL, 
  pineconeBaseURL,
  chatSyncBaseURL,
  agentBaseURL,
  aiWorkflowsBaseURL,
  flowBuilderApiBaseURL
} = getBaseUrls();

const createAxiosInstance = url =>
  axios.create({
    baseURL: url, // Dynamically passed
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      Authorization: '',
    },
  });

const logEventsInstance = createAxiosInstance(logEventsBaseURL);
const integrationsInstance = createAxiosInstance(integrationBaseURL);
const instance = createAxiosInstance(baseURL);
const aiInstance = createAxiosInstance(aiBaseURL);
const inboxInstance = createAxiosInstance(inboxBaseURL);
const inboxInstanceUnauth = createAxiosInstance(inboxBaseURL);
const inboxWidgetInstance = createAxiosInstance(inboxBaseURL);
const teamsInstance = createAxiosInstance(teamsBaseURL);
const authInstance = createAxiosInstance(inboxBaseURL);
const reportsInstance = createAxiosInstance(reportsBaseURL);
const activityInstance = createAxiosInstance(activityBaseURL);
const activtiyReportsInstance = createAxiosInstance(activityBaseURL);
const articlesInstance = createAxiosInstance(articlesBaseURL);
const aiSearchInstance = createAxiosInstance(aiSearchBaseURL);
const adminInstance = createAxiosInstance(adminBaseURL);
const userFlowInstance = createAxiosInstance(userFlowBaseURL);
const pineconeInstance = createAxiosInstance(pineconeBaseURL);
const chatSyncInstance = createAxiosInstance(chatSyncBaseURL);
const agentInstance = createAxiosInstance(agentBaseURL);
const aiWorkflowsInstance = createAxiosInstance(aiWorkflowsBaseURL);
const flowBuilderApiInstance = createAxiosInstance(flowBuilderApiBaseURL);
const regenerateToken = async () => {
  let token = localStorage.getItem('inbox-chat-token');
  const tokenTime = localStorage.getItem('token-time');

  if (tokenTime) {
    const now = moment.utc();
    const storedTime = moment.utc(+tokenTime).valueOf();
    const diffInHours = now.diff(storedTime, 'hours');

    if (diffInHours >= 23) {
      const payload = {
        email: localStorage.getItem('user_email'),
        user_id: localStorage.getItem('user_id'),
        support_lib_id: localStorage.getItem('support_Lib_id'),
      };

      const getFreshToken = async () => {
        const user = firebase.auth().currentUser;
        if (user) {
          return await user.getIdToken(true);
        } else {
          throw new Error('No user is signed in.');
        }
      };
      let loginToken = '';
      await getFreshToken()
        .then(token => {
          // console.log('Fresh Token:', token)
          loginToken = token;
        })
        .catch(error => {
          console.error('Error fetching token:', error);
        });

      try {
        const res = await authInstance.post('/login', payload, {
          headers: {
            Authorization: `Bearer ${loginToken}`,
          },
        });

        if (res.data.token) {
          localStorage.setItem('inbox-chat-token', res.data.token);
          token = res.data.token;
          localStorage.setItem('token-time', moment.utc().valueOf().toString());
        }
      } catch (err) {
        store.dispatch('printLog', { text: 'Error while refetching token', log: err });
      }
    }
  }
};

userFlowInstance.interceptors.request.use(async config => {
  await regenerateToken();
  const token = localStorage.getItem('inbox-chat-token');
  if (token && config.headers) config.headers.Authorization = `Bearer ${token}`;
  config.validateStatus = status => status < 400;
  return config;
});
instance.interceptors.request.use(async config => {
  await regenerateToken();
  const token = localStorage.getItem('inbox-chat-token');
  if (token && config.headers) config.headers.Authorization = `Bearer ${token}`;
  config.validateStatus = status => status < 400;
  return config;
});

teamsInstance.interceptors.request.use(async config => {
  await regenerateToken();
  const token = localStorage.getItem('inbox-chat-token');
  if (token && config.headers) config.headers.Authorization = `Bearer ${token}`;
  config.validateStatus = status => status < 400;
  return config;
});

inboxInstance.interceptors.request.use(async config => {
  await regenerateToken();
  const token = localStorage.getItem('inbox-chat-token');
  if ((token && config.headers) && !config.headers.Authorization) config.headers.Authorization = `Bearer ${token}`;
  config.validateStatus = status => status < 400;
  return config;
});

logEventsInstance.interceptors.request.use(async config => {
  await regenerateToken();
  const token = localStorage.getItem('inbox-chat-token');
  if (token && config.headers) config.headers.Authorization = `Bearer ${token}`;
  config.validateStatus = status => status < 400;
  return config;
});

reportsInstance.interceptors.request.use(async config => {
  await regenerateToken();
  const token = localStorage.getItem('inbox-chat-token');
  if (token && config.headers) config.headers.Authorization = `Bearer ${token}`;
  config.validateStatus = status => status < 400;
  return config;
});

activityInstance.interceptors.request.use(async config => {
  const token = process.env.VUE_APP_ACTIVITY_API_KEY;
  if (token && config.headers) config.headers.Authorization = token;
  config.validateStatus = status => status < 400;
  return config;
});

activtiyReportsInstance.interceptors.request.use(async config => {
  const token = process.env.VUE_APP_ACTIVITY_API_KEY;
  const localToken = localStorage.getItem('inbox-chat-token');
  if (localToken && config.headers) config.headers.Authorization = `Bearer ${localToken}`;
  config.validateStatus = status => status < 400;
  return config;
});

adminInstance.interceptors.request.use(async config => {
  const localToken = localStorage.getItem('inbox-chat-token');
  if (localToken && config.headers) config.headers.Authorization = `Bearer ${localToken}`;
  config.validateStatus = status => status < 400;
  return config;
});


articlesInstance.interceptors.request.use(async config => {
  const token = process.env.VUE_APP_ARTICLES_API_KEY;
  if (token && config.headers) config.headers['x-api-key'] = token;
  config.validateStatus = status => status < 400;
  return config;
});

aiSearchInstance.interceptors.request.use(async config => {
  const token = process.env.VUE_APP_ARTICLES_API_KEY;
  if (token && config.headers) config.headers['x-api-key'] = token;
  config.validateStatus = status => status < 400;
  return config;
});

pineconeInstance.interceptors.request.use(async config => {
  const localToken = localStorage.getItem('inbox-chat-token');
  if (localToken && config.headers) config.headers.Authorization = `Bearer ${localToken}`;
  config.validateStatus = status => status < 400;
  return config;
});

chatSyncInstance.interceptors.request.use(async config => {
  const localToken = localStorage.getItem('inbox-chat-token');
  if (localToken && config.headers) config.headers.Authorization = `Bearer ${localToken}`;
  config.validateStatus = status => status < 400;
  return config;
});

agentInstance.interceptors.request.use(async config => {
  const localToken = localStorage.getItem('inbox-chat-token');
  if (localToken && config.headers) config.headers.Authorization = `Bearer ${localToken}`;
  config.validateStatus = status => status < 400;
  return config;
});

aiWorkflowsInstance.interceptors.request.use(async config => {
  const localToken = localStorage.getItem('inbox-chat-token');
  if (localToken && config.headers) config.headers.Authorization = `Bearer ${localToken}`;
  config.validateStatus = status => status < 400;
  return config;
});

flowBuilderApiInstance.interceptors.request.use(async config => {
  const localToken = localStorage.getItem('inbox-chat-token');
  if (localToken && config.headers) config.headers.Authorization = `Bearer ${localToken}`;
  config.validateStatus = status => status < 400;
  return config;
});
inboxInstance.interceptors.response.use(
  successRes => {
    // console.log('successRes', successRes)
    return successRes;
  },
  error => {
    // console.log('error', error)
    // sweetalert({
    //     title: "Error!",
    //     text: error?.response?.data?.message
    //         ? error?.response?.data?.message
    //         : "An error occurred",
    //     icon: "error",
    //     buttons: {
    //         confirm: {
    //             text: "Close",
    //             value: true,
    //             visible: true,
    //             className: "btn bg-gradient-danger mx-auto",
    //             closeModal: true,
    //         },
    //     },
    // });
    store.dispatch('printLog', { text: 'caught error', log: error?.response?.status });
    const { logout } = useLogout();
    if (error?.response?.status == 401) {
      if (store.state.socket) {
        store.state.socket.close(1000, 'Logout');
      }
      logout();
    }
    return Promise.reject(error);
  },
);

const Api = {
  getSopCategories: async (params) => {
    return await instance.get(`sop_categories`, {params});
  },
  // Flowbuilder - userflows via external API with same bearer handling (inboxInstance)
  getUserflows: async params => {
    const url = `${flowBuilderApiBaseURL}/mflows`;
    return await inboxInstance.get(url, { params });
  },
  updateUserflow: async (body, params) => {
    const url = `${flowBuilderApiBaseURL}/mflows`;
    return await inboxInstance.put(url, body, { params });
    
  },
  deleteUserflow: async payload => {
    const url = `${flowBuilderApiBaseURL}/mflows`;
    return await inboxInstance.delete(url, { data: payload });
  },
  duplicateFlow: async payload => {
    const url = `${flowBuilderApiBaseURL}/duplicateflow`;
    return await inboxInstance.post(url, payload);
  },
  getLaunchers: async params => {
    const url = `${flowBuilderApiBaseURL}/launchers`;
    return await inboxInstance.get(url, { params });
  },
  deleteLauncher: async payload => {
    const url = `${flowBuilderApiBaseURL}/launchers`;
    return await inboxInstance.delete(url, { data: payload });
  },
  duplicateLauncher: async payload => {
    const url = `${flowBuilderApiBaseURL}/duplicatelauncher`;
    return await inboxInstance.post(url, payload);
  },
  publishFlowVersion: async body => {
    const url = `${flowBuilderApiBaseURL}/mflow_versions`;
    return await inboxInstance.post(url, body);
  },
  getEnvironments: async params => {
    const url = `${flowBuilderApiBaseURL}/environments`;
    return await inboxInstance.get(url, { params });
  },
  createEnvironment: async body => {
    const url = `${flowBuilderApiBaseURL}/environments`;
    return await inboxInstance.post(url, body);
  },
  updateEnvironment: async body => {
    const url = `${flowBuilderApiBaseURL}/environments`;
    return await inboxInstance.put(url, body);
  },
  deleteEnvironment: async payload => {
    const url = `${flowBuilderApiBaseURL}/environments`;
    return await inboxInstance.delete(url, { data: payload });
  },
  getEnvStyles: async envRef => {
    const url = `${flowBuilderApiBaseURL}/envstyles`;
    return await inboxInstance.get(url, { params: { env_ref: envRef } });
  },
  updateEnvStyles: async (envRef, body) => {
    const url = `${flowBuilderApiBaseURL}/envstyles`;
    return await inboxInstance.post(url, body, { params: { env_ref: envRef } });
  },
  getSopArticlesbackend: async params => {
    let url = `sop_articles`;
    return await instance.get(url, {params});
  },
  getCoursesLessonsbackend: async params => {
    let url = `courses_lessons`;
    return await instance.get(url, {params});
  },
  getCoursesLessonsFrontend: async params => {
    let url = `courses_lessons`;
    return await instance.get(url, {params});
  },
  getCourses: async params => {
    let url = `courses?support_lib_id=${params.support_lib_id}&rut=admin&published=all`;
    if (params.library_type) {
      url += `&library_type=${params.library_type}`;
    }
    return await instance.get(url);
  },
  getSubscription: async () => {
    return await instance.get('subscriptions');
  },
  getNotifications: async params => {
    return await inboxInstance.get(`/agent_notifications?support_lib_id=${params.support_lib_id}`);
  },
  updateNotifications: async payload => {
    return await inboxInstance.put(`/agent_notifications`, payload);
  },
  login: async (payload, token) => {
    return await inboxInstance.post(`/login`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  regenerateToken: async () => {
    const getFreshToken = async () => {
      const user = firebase.auth().currentUser;
      if (user) {
        return await user.getIdToken(true);
      } else {
        throw new Error('No user is signed in.');
      }
    };
    let loginToken = '';
    await getFreshToken()
      .then(token => {
        // console.log('Fresh Token:', token)
        loginToken = token;
      })
      .catch(error => {
        store.dispatch('printLog', { text: 'Error fetching token: ', log: error, type: 'error' });
        console.error('Error fetching token:', error);
      });
    let payload = {
      email: localStorage.getItem('user_email'),
      user_id: localStorage.getItem('user_id'),
      support_lib_id: localStorage.getItem('support_Lib_id'),
    };
    try {
      let res = await axios.post(`${inboxBaseURL}/login`, payload, {
        headers: {
          Authorization: `Bearer ${loginToken}`,
        },
      });
      if (res?.data?.token) {
        localStorage.setItem('inbox-chat-token', res.data.token);
      }
    } catch (error) {
      store.dispatch('printLog', { text: 'payload error', log: error });
    }
  },

  getNotificationSubscription: async params => {
    let url = `/notification_subscriptions`;
    return await inboxInstance.get(url, {params});
  },

  submitNewNotificationSubscription: async payload => {
    return await inboxInstance.post('/notification_subscriptions', payload);
  },

  updateNotificationSubscription: async (params, payload) => {
    let url = `notification_subscriptions`;
    return await inboxInstance.put(url, payload, {params});
  },

  deleteNotificationSubscription: async payload => {
    return await inboxInstance.delete(`/notification_subscriptions`, { data: payload });
  },

  updateAgentInformation: async payload => {
    return await inboxInstance.put(`/user`, payload);
  },
  getAgentList: async params => {
    let url = `agents`;
    return await inboxInstance.get(url, {params});
  },
  getAgentListForWidget: async params => {
    let url = `agents`;
    return await inboxWidgetInstance.get(url, {params});
  },
  getLoggedInUser: async (params = undefined) => {
    let url = `user`;
    return await inboxInstance.get(url, {params});
  },
  deleteAgentProfileImage: async payload => {
    return await inboxInstance.put(`user`, payload);
  },
  updateAgencyAction: async payload => {
    const token = localStorage.getItem('inbox-chat-token');
    const headers = {
      'Content-Type': 'application/json; charset=utf-8',
      Authorization: `Bearer ${token}`,
    };
    return await inboxInstance.patch(`agency`, payload, { headers: headers });
  },
  submitAgencyDetails: async payload => {
    const token = localStorage.getItem('inbox-chat-token');
    const headers = {
      'Content-Type': 'application/json; charset=utf-8',
      Authorization: `Bearer ${token}`,
    };
    return await inboxInstance.post(`agency`, payload, { headers: headers });
  },
  updateAgencyDetails: async payload => {
    const token = localStorage.getItem('inbox-chat-token');
    const headers = {
      'Content-Type': 'application/json; charset=utf-8',
      Authorization: `Bearer ${token}`,
    };
    return await inboxInstance.put(`agency`, payload, { headers: headers });
  },

  getTicketStatuses: async support_lib_id => {
    return await inboxInstance.get(`ticket_statuses?support_lib_id=${support_lib_id}`);
  },
  updateTicketStatus: async payload => {
    return await inboxInstance.patch(`tickets`, payload);
  },

  listTicketType: async (support_lib_id, params = {}) => {
    const searchParams = new URLSearchParams();
    if (support_lib_id) {
      searchParams.set('support_lib_id', support_lib_id);
    }
    Object.entries(params || {}).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') {
        return;
      }
      searchParams.set(key, Array.isArray(value) ? value.join(',') : String(value));
    });
    return await inboxInstance.get(`ticket_types?${searchParams.toString()}`);
  },
  submitNewTicketType: async payload => {
    return await inboxInstance.post(`ticket_types`, payload);
  },
  updateTicketType: async (payload, ticket_type_ref) => {
    return await inboxInstance.put(`ticket_types?ticket_type_ref=${ticket_type_ref}`, payload);
  },
  deleteTicketType: async payload => {
    return await inboxInstance.delete(`ticket_types`, { data: payload });
  },

  listTicketCategories: async support_lib_id => {
    return await inboxInstance.get(`ticket_categories?support_lib_id=${support_lib_id}`);
  },
  submitNewTicketCategory: async payload => {
    return await inboxInstance.post(`ticket_categories`, payload);
  },
  updateTicketCategory: async (payload, ticket_category_ref) => {
    return await inboxInstance.put(`ticket_categories?ticket_category_ref=${ticket_category_ref}`, payload);
  },
  deleteTicketCategory: async payload => {
    return await inboxInstance.delete(`ticket_categories`, { data: payload });
  },
  listTicketTiers: async support_lib_id => {
    return await inboxInstance.get(`ticket_tiers?support_lib_id=${support_lib_id}`);
  },
  submitNewTicketTier: async payload => {
    return await inboxInstance.post(`ticket_tiers`, payload);
  },
  updateTicketTier: async (payload, ticket_tier_ref) => {
    return await inboxInstance.put(`ticket_tiers?ticket_tier_ref=${ticket_tier_ref}`, payload);
  },
  deleteTicketTier: async payload => {
    return await inboxInstance.delete(`ticket_tiers`, { data: payload });
  },
  removeGoogleIntegration: async payload => {
    return await integrationsInstance.delete(`google/auth`, { data: payload });
  },
  removeMailgunIntegration: async payload => {
    return await integrationsInstance.delete(`mailgun/auth`, { data: payload });
  },
  updateTicketCategoryAndTierStatus: async payload => {
    return await inboxInstance.patch(`tickets`, payload);
  },
  searchCoPilot: async payload => {
    return await aiInstance.post(`search`, payload);
  },
  listChildLibraries: async params => {
    return await inboxInstance.get(`agency?support_lib_id=${params.support_lib_id}&list_children=1`);
  },
  getWorkflows: async params => {
    let url = `workflows`;
    return await inboxInstance.get(url, {params});
  },
  createWorkflow: async payload => {
    return await inboxInstance.post(`workflows`, payload);
  },
  updateWorkflow: async (payload, params) => {
    let url = `workflows`;
    return await inboxInstance.put(url, payload, {params});
  },
  updateWorkflowStatus: async (payload, params) => {
    let url = `workflows`;
    return await inboxInstance.patch(url, payload, {params});
  },
  deleteWorkflow: async payload => {
    return await inboxInstance.delete(`workflows`, { data: payload });
  },
  getWorkflowFolders: async params => {
    let url = `workflow_folders`;
    return await inboxInstance.get(url, {params});
  },
  createWorkflowFolder: async payload => {
    return await inboxInstance.post(`workflow_folders`, payload);
  },
  updateWorkflowFolder: async (payload, params) => {
    let url = `workflow_folders`;
    return await inboxInstance.put(url, payload, {params});
  },
  deleteWorkflowFolder: async payload => {
    return await inboxInstance.delete(`workflow_folders`, { data: payload });
  },
  getModalWidgetDetails: async params => {
    let url = `modal_widgets`;
    return await inboxInstance.get(url, {params});
  },
  getModalWidgetDetailsForWidget: async (params = undefined) => {
    let url = `modal_widgets`;
    return await inboxWidgetInstance.get(url, {params});
  },
  fetchTags: async params => {
    let url = `conv_tags`;
    return await inboxInstance.get(url, {params});
  },
  addTags: async payload => {
    return await inboxInstance.post(`conv_tags`, payload);
  },

  getMentionChats: async url => {
    return await inboxInstance.get(url);
  },

  updateconversation: async payload => {
    return await inboxInstance.patch(`conversations`, payload);
  },

  getPermissions: async params => {
    return await teamsInstance.get(`permissions/${params.ref_uid}/${params.role}`);
  },

  updatePermissions: async (payload, ref_uid) => {
    return await teamsInstance.put(`updatepermissions/${ref_uid}`, payload);
  },

  deletePermissions: async (ref_uid, agency_ref) => {
    return await teamsInstance.delete(`permissions/${ref_uid}/${agency_ref}`);
  },

  getOrganizationRoles: async support_lib_id => {
    return await teamsInstance.get(`roles/${support_lib_id}`);
  },

  getLogEvents: async (params, query) => {
    let url = `EventHistory`;
    if (params?.workflow_ref) {
      url += `/${params?.workflow_ref}/1`;
    }
    if (params?.threadId) {
      url += `/${params?.threadId}/2`;
    }
    return await logEventsInstance.get(url, {params:query});
  },

  getScreenShareData: async (params, payload) => {
    let url = `cobrowsewatchurl/${params.visitor_ref}`;
    console.log('[upscope-debug][agent-api] getScreenShareData: POST', {
      url,
      conversation_ref: params.visitor_ref,
      agent_id: payload?.agent_id,
      agent_name: payload?.agent_name,
      support_lib_id: payload?.support_lib_id,
      on_end_url: payload?.on_end_url,
    });
    try {
      const res = await teamsInstance.post(url, payload);
      console.log('[upscope-debug][agent-api] getScreenShareData: response', {
        status: res?.status,
        has_watch_link: !!res?.data?.watch_link,
        error: res?.data?.error || null,
      });
      return res;
    } catch (err) {
      console.log('[upscope-debug][agent-api] getScreenShareData: error', {
        message: err?.message,
        status: err?.response?.status,
        data: err?.response?.data,
      });
      throw err;
    }
  },

  ticketCreatedMethods: async params => {
    let url = `ticket_methods`;
    return await inboxInstance.get(url, {params});
  },

  getIntegrationsEmail: async (params, payload) => {
    let url = `/${params?.emailType}?support_lib_id=${params.support_lib_id}`;
    return await integrationsInstance.get(url);
  },

  changeIntegrationsEmail: async (params, payload) => {
    let url = `/${params?.emailType}?supportLibId=${params.support_lib_id}`;
    return await integrationsInstance.put(url, payload);
  },

  /* form builder */
  getFormbuilderForms: async params => {
    let url = `getformlist`;
    return await teamsInstance.get(url, {params});
  },

  updateForm: async (params, payload) => {
    return await teamsInstance.patch(`renameform/${params.contact_form_ref}`, payload);
  },

  deleteForm: async params => {
    return await teamsInstance.delete(`deleteform/${params.contact_form_ref}`);
  },

  updateFormStatus: async (params, payload) => {
    return await teamsInstance.patch(`publishform/${params.contact_form_ref}`, payload);
  },

  getForm: async params => {
    let url = `/getform`;
    if (params?.contact_form_ref) {
      url += `/${params?.contact_form_ref}`;
    }
    return await teamsInstance.get(url);
  },
  /// flow builder

  getFlowbuilderFlows: async params => {
    let url = `getformlist`;
    return await teamsInstance.get(url, {params});
  },

  updateFlow: async (params, payload) => {
    return await teamsInstance.patch(`renameflow/${params.flow_ref}`, payload);
  },

  deleteFlow: async params => {
    return await teamsInstance.delete(`deleteflow/${params.flow_ref}`);
  },

  updateFlowStatus: async (params, payload) => {
    return await teamsInstance.patch(`publishflow/${params.flow_ref}`, payload);
  },

  /// flow builder ends here

  markMentionAsSeen: async payload => {
    return await inboxInstance.patch(`messages`, payload);
  },

  getConversationFormFields: async params => {
    let url = `widget_form_submissions`;
    return await inboxInstance.get(url, {params});
  },
  /* ends here */

  getSmartQueuesList: async (params = undefined) => {
    let url = `smart_queues`;
    return await inboxInstance.get(url, {params});
  },

  createSmartQueue: async payload => {
    let url = `smart_queues`;
    return await inboxInstance.post(url, payload);
  },

  updateSmartQueue: async (payload, params) => {
    let url = `smart_queues`;
    return await inboxInstance.put(url, payload, {params});
  },

  deleteSmartQueue: async payload => {
    let url = `smart_queues`;
    return await inboxInstance.delete(url, { data: payload });
  },
  getDraftMessages: async (params) => {
    let url = `draft_messages`;
    return inboxInstance.get(url, {params});
  },
  deleteTeam: async payload => {
    let url = 'teams';
    return await inboxInstance.delete(url, { data: payload });
  },
  createTeam: async payload => {
    let url = 'teams';
    return await inboxInstance.post(url, payload);
  },
  createSearchFilter: async payload => {
    let url = 'saved_filters';
    return await inboxInstance.post(url, payload);
  },
  updateSearchFilter: async (params, payload) => {
    let url = `saved_filters`;
    return await inboxInstance.put(url, payload, {params});
  },
  getSearchFilterList: async (params = undefined) => {
    let url = 'saved_filters';
    return await inboxInstance.get(url, {params});
  },
  deleteSmartSearchList: async payload => {
    let url = 'saved_filters';
    return await inboxInstance.delete(url, { data: payload });
  },
  addArticleActivity: async payload => {
    let url = 'articles';
    return await activityInstance.post(url, payload);
  },
  addSearchActivity: async payload => {
    let url = 'searches';
    return await activityInstance.post(url, payload);
  },
  updateSearchActivity: async payload => {
    let url = 'searches';
    return await activityInstance.patch(url, payload);
  },
  addNewsFlashActivity: async payload => {
    let url = 'newsflash';
    return await activityInstance.post(url, payload);
  },
  addWidgetActivity: async payload => {
    let url = 'widget';
    return await activityInstance.post(url, payload);
  },
  addChatsActivity: async payload => {
    let url = 'chats';
    return await activityInstance.post(url, payload);
  },

  async sendApplicationWebSocket(payload) {
    const isOpen = ws => {
      switch (ws.readyState) {
        case ws.CONNECTING: // 0
          return 'connecting'; // Socket created but not yet connected
        case ws.OPEN: // 1
          return 'open'; // Connection ready for communication
        case ws.CLOSING: // 2
          return 'closing'; // Connection is in process of closing
        case ws.CLOSED: // 3
          return 'closed'; // Connection is closed or failed
        default:
          return 'unknown';
      }
    };
    let token = localStorage.getItem('inbox-chat-token');
    let data = { ...payload, sent_via: 'application', dname: window.location.hostname };
    if (token) {
      data = { ...data, sender_ref: token };
    }
    if(store.state.support_lib_id == process.env.VUE_APP_HLPT_PARENT_SUPPORT_LIB_ID) {
      data = {...data, dm: store.getters.isDemoMode ? 1 : 0 }
    }
    if (store.state.socket && !store.state.socket_connection_closed) {
      if (store.state.socketStatus(store.state.socket) === 'open') {
        if ((store.state.isSocketConnectionRegenerating && data.action == 'sendPrivate') || (store.state.internet_connection == 'offline' && data.action == 'sendPrivate')) {
          // console.log('pushing to message queue socket is reconnecting', data);
          store.state.message_queue.push(data);
        } else {
          await store.state.socket.send(JSON.stringify(data));
          await store.dispatch('printLog', { text: `action ${data.action} sent`, log: data });
        }
      } else if (store.state.socketStatus(store.state.socket) === 'connecting') {
        store.dispatch('printLog', { text: `Socket issue: `, log: 'Socket is connecting', type: 'error' });
        if ((store.state.isSocketConnectionRegenerating && data.action == 'sendPrivate') || (store.state.internet_connection == 'offline' && data.action == 'sendPrivate')) {
          store.state.message_queue.push(data);
        }
      } else if (store.state.socketStatus(store.state.socket) === 'closing') {
        if ((store.state.isSocketConnectionRegenerating && data.action == 'sendPrivate') || (store.state.internet_connection == 'offline' && data.action == 'sendPrivate')) {
          store.state.message_queue.push(data);
        }
        store.dispatch('printLog', { text: `Socket issue: `, log: 'Socket is closing', type: 'error' });
      } else if (store.state.socketStatus(store.state.socket) === 'closed') {
        if ((store.state.isSocketConnectionRegenerating && data.action == 'sendPrivate') || (store.state.internet_connection == 'offline' && data.action == 'sendPrivate')) {
          store.state.message_queue.push(data);
        }
        store.dispatch('printLog', { text: `Socket issue: `, log: 'Socket is closed', type: 'error' });
      } else {
        store.dispatch('printLog', { text: `Socket issue: `, log: 'Socket status is unknown', type: 'error' });
      }
    } else {
      if (store.state.socket_connection_closed) {
        store.dispatch('printLog', { text: `Socket issue: `, log: `Action ${data.action} was not sent because socket_connection_closed is true`, type: 'error' });
      } else {
        store.dispatch('printLog', { text: `Socket issue: `, log: `Action ${data.action} was not sent because socket state is null`, type: 'error' });
      }
    }
  },
  sendWidgetWebSocket(payload) {
    let data = { ...payload, sent_via: 'widget' };

    if (store.state.isSocketReleased) {
      return;
    }
    // Initial new-ui chat uses requestChat on socket open; do not queue/sendPrivate in parallel.
    const hasNewUiActiveSession = () => {
      const queueRef = store.state.visitor_connection_queue_ref
        || (typeof localStorage !== 'undefined' ? localStorage.getItem('visitor_connection_queue_ref') : '');
      if (queueRef) return true;
      return (store.state.frontendMessages || []).some((m) => (
        m && m.sender_type === 'visitor' && m.message_type !== 'new_ui_welcome_typing'
      ));
    };
    if (
      data.action === 'sendPrivate'
      && store.state.isConnecting
      && store.state.isNewUiChatData
      && !hasNewUiActiveSession()
    ) {
      store.dispatch('printLog', {
        text: 'Skipping sendPrivate during initial new-ui chat connect',
        log: data,
        type: 'log',
      });
      return;
    }
    const shouldQueueSendPrivate = (action) => {
      if (action !== 'sendPrivate') return false;
      if (store.state.internet_connection === 'offline') return true;
      if (!store.state.isSocketReconnecting) return false;
      if (store.state.isConnecting && store.state.isNewUiChatData) return false;
      return true;
    };
    if (store.state.socket) {
      if (store.state.socketStatus(store.state.socket) === 'open') {
        store.dispatch('printLog', { text: `action ${data.action}`, log: data });
        if (shouldQueueSendPrivate(data.action)) {
          store.state.message_queue.push(data);
        } else {
          store.state.socket.send(JSON.stringify(data));
        }
      } else if (store.state.socketStatus(store.state.socket) === 'connecting') {
        if (shouldQueueSendPrivate(data.action)) {
          store.state.message_queue.push(data);
        }
        store.dispatch('printLog', { text: `Socket issue: `, log: 'Socket is connecting', type: 'error' });
      } else if (store.state.socketStatus(store.state.socket) === 'closing') {
        if (shouldQueueSendPrivate(data.action)) {
          store.state.message_queue.push(data);
        }
        store.dispatch('printLog', { text: `Socket issue: `, log: 'Socket is closing', type: 'error' });
      } else if (store.state.socketStatus(store.state.socket) === 'closed') {
        if (shouldQueueSendPrivate(data.action)) {
          store.state.message_queue.push(data);
        }
        store.dispatch('printLog', { text: `Socket issue: `, log: 'Socket is closed', type: 'error' });
      } else {
        store.dispatch('printLog', { text: `Socket issue: `, log: 'Socket status is unknown', type: 'error' });
      }
    } else {
      store.dispatch('printLog', { text: `Socket issue: `, log: `Action ${data.action} was not sent because socket state is null`, type: 'error' });
    }
  },
  getAgencyDetails: async (params = undefined) => {
    let url = `agency`;
    return await inboxInstance.get(url, {params:params || {}});
  },
  getAgencyDetailsUnauth: async (params = undefined) => {
    let url = `agency`;
    return await inboxInstanceUnauth.get(url, {params});
  },

  getCsatOverview: async (params = undefined) => {
    let url = `getcsatoverview`;
    return await reportsInstance.get(url, {params});
  },
  getConversationsCount: async (params = undefined) => {
    let url = `getconversationscount`;
    return await reportsInstance.get(url, {params});
  },
  getSupportOverview: async (params = undefined) => {
    let url = `getsupportoverview`;
    return await reportsInstance.get(url, {params});
  },
  getTicketReports: async (params = undefined) => {
    let url = `getticketreports`;
    return await reportsInstance.get(url, {params});
  },
  getChatReports: async (params = undefined) => {
    let url = `getchatreports`;
    return await reportsInstance.get(url, {params});
  },
  getDetailedConversations: async (params = undefined) => {
    let url = `getdetailedconversations`;
    return await reportsInstance.get(url, {params});
  },
  getDetailedChats: async (params = undefined) => {
    let url = `getdetailedchats`;
    return await reportsInstance.get(url, {params});
  },
  getDetailedTicket: async (params = undefined) => {
    let url = `getdetailedtickets`;
    return await reportsInstance.get(url, {params});
  },
  getReports: async (params = undefined) => {
    let url = `getreports`;
    return await reportsInstance.get(url, {params});
  },

  getCustomReports: async (params = undefined, chartStructure = null) => {
    let url = `getreports`;
    return await reportsInstance.post(url, chartStructure, {params});
  },
  getTeammateRatings: async (params = undefined) => {
    let url = `getteammateratings`;
    return await reportsInstance.get(url, {params});
  },
  getDetailedCustomerSatisfaction: async (params = undefined) => {
    let url = `getdetailedratingreports`;
    return await reportsInstance.get(url, {params});
  },
  getTeamsList: async params => {
    let url = `teams`;
    return await inboxInstance.get(url, {params});
  },
  getTeammates: async params => {
    let url = `agents`;
    return await inboxInstance.get(url, {params});
  },
  updateTeam: async (params, payload) => {
    let url = 'teams';
    return await inboxInstance.put(url, payload, {params});
  },
  updateTeammateInfo: async payload => {
    let url = 'agents';
    return await inboxInstance.patch(url, payload);
  },
  getFilters: async (params = undefined) => {
    let url = `getfilters`;
    return await reportsInstance.get(url, {params});
  },
  getMetrics: async (params = undefined) => {
    let url = `getmetrics`;
    return await reportsInstance.get(url, {params});
  },

  getTeamList: async (params = undefined) => {
    let url = `teams`;
    return await inboxInstance.get(url, {params});
  },
  /** Get cards and charts analytics */
  async getReportsAnalytics(params) {
    let url = `analytics`;
    return await reportsInstance.get(url, {params});
  },

  /** Get report analytics detailed information, tables and drills*/
  async getDetailedReportsAnalytics(params) {
    let url = `detailedanalytics`;
    return await reportsInstance.get(url, {params});
  },
  /** Get report analytics detailed information, tables and drills*/
  async getDetailedReports(params) {
    let url = `getdetailedreports`;
    return await reportsInstance.get(url, {params});
  },
  /** Get default templates */
  async getReportTemplates(params) {
    let url = `reports`;
    const response = await reportsInstance.get(url, {params});
    return response;
  },

  /** Get layout by id */
  async getReportDetails(id, params) {
    if (!id) return;
    let url = `getreportdetails/${id}`;
    const response = await reportsInstance.get(url, {params});

    return response;
  },
  getTicketType: async (params = undefined) => {
    let url = `gettickettypes`;
    return await reportsInstance.get(url, {params});
  },
  // gettickettypes
  /** Create new report */
  async createNewReport(payload, params = null) {
    let url = `reports`;
    return await reportsInstance.post(url, payload, {params});
  },
  /** Update report */
  async updateReport(payload, params = null) {
    let url = `reports`;
    return await reportsInstance.put(url, payload, {params});
  },

  /** Mark report as favorite */
  async markReportAsFavorite(body, params = null) {
    let url = `markasfavorite`;
    return await reportsInstance.post(url, body, {params});
  },
  /** Delete report */
  async deleteReport(body, params = null) {
    let url = `reports`;
    return await reportsInstance.delete(url, { data: body, params: params || undefined});
  },

  async updateReportChart(payload, params = null) {
    let url = `updatereportcards`;
    return await reportsInstance.post(url, payload, {params});
  },

  /** Activity logs */
  async getActivities(params = null) {
    let url = `activities`;
    return await activtiyReportsInstance.get(url, {params});
  },

  async getActivityPermissions(params = null) {
    let url = `permissions`;
    return await activtiyReportsInstance.get(url, {params});
  },

  async getActivityLogs(params = null) {
    let url = 'activity-logs';
    return await activtiyReportsInstance.get(url, {params});
  },

  async getAutomations(params = null) {
    let url = `workflows`;
    return await activtiyReportsInstance.get(url, {params});
  },

  async getActivityFeeds(params = null) {
    let url = '/feeds';
    if (params) {
      url += '?' + new URLSearchParams(params).toString();
    }
    return await activtiyReportsInstance.get(url);
  },

  async markFeedAsRead(payload) {
    let url = `/feeds/read`;
    return await activtiyReportsInstance.post(url, payload);
  },

  getReportCategories: async (params = undefined) => {
    let url = `getreportcategories`;
    return await reportsInstance.get(url, {params});
  },

  getChartTypes: async (params = undefined) => {
    let url = `getcharttypes`;
    return await reportsInstance.get(url, {params});
  },

  getEmailLogs: async (params = undefined) => {
    let url = `email-logs`;
    return await activtiyReportsInstance.get(url, {params});
  },

  searchArticles: async payload => {
    let url = `search`;
    return await aiSearchInstance.post(url, payload);
  },

  getDomainStatus: async (payload, params = null) => {
    let url = `getdomainstatus`;
    return await reportsInstance.post(url, payload, {params});
  },

  // https://reports.modalsupport.net/dev/getsnapshots?id=50163
  getMonitorSnapshots: async (params = null) => {
    let url = `getsnapshots`;
    return await reportsInstance.get(url, {params});
  },

  getPredictiveSearch: async payload => {
    let url = `search`;
    return await aiSearchInstance.post(url, payload);
  },
  getConversationMessages: async params => {
    // GET /messages?support_lib_id={id}&conv_view=admin&conv_ref={ref}
    const query = new URLSearchParams({
      support_lib_id: params.support_lib_id,
      conv_view: params.conv_view || 'admin',
      conv_ref: params.conv_ref,
    }).toString();
    return await inboxInstance.get(`/messages?${query}`);
  },

  getPrioritySupport: async () => {
    return await inboxInstance.get(`priority_support`);
  },

  updatePrioritySupport: async (payload) => {
    return await inboxInstance.put(`priority_support`, payload);
  },

  loginAs: async (payload) => {
    return await adminInstance.post(`loginas`, payload);
  },

  logoutAs: async (payload) => {
    return await adminInstance.patch(`loginas`, payload);
  },

  addArticlesOrNewsFlashReaction: async (payload) => {
    return await activityInstance.post(`reactions`, payload);
  },

  getModalAiSettings: async (params = null) => {
    let url = `modalai_settings`;
    return await inboxInstance.get(url, {params});
  },

  updateModalAiSettings: async (payload, params = null) => {
    let url = `modalai_settings`;
    return await inboxInstance.post(url, payload, {params});
  },

  getAILogs: async (params = null) => {
    let url = `ModalAILogs`;
    return await logEventsInstance.get(url, {params});
  },

  getPromptLogs: async (params = null) => {
    let url = `ModalAILogs/getPromptLogs`;
    return await logEventsInstance.get(url, {params});
  },

  getPineConeArticles: async (params = null) => {
    let url = `articles`;
    return await pineconeInstance.get(url, {params});
  },

  GetModalErrorLogs: async (params = null) => {
    let url = `ModalErrorLogs`;
    return await logEventsInstance.get(url, {params});
  },
  getModalErrorLogsServices: async (params = null) => {
    let url = `ModalErrorLogs/services`;
    return await logEventsInstance.get(url, {params});
  },
  resyncDataSync: async (payload = null) => {
    let url = `resync`;
    return await chatSyncInstance.post(url, payload);
  },
  getCustomDocs: async (params = null) => {
    let url = `modalai_docs`;
    return await inboxInstance.get(url, {params});
  },
  submitCustomDoc: async (payload = null) => {
    let url = `modalai_docs`;
    let headers = {
      'Content-Type': 'multipart/form-data',
      'Authorization': `Bearer ${localStorage.getItem('inbox-chat-token')}`,
    };
    return await inboxInstance.post(url, payload, {headers});
  },
  getCustomDocByRef: async (params = null) => {
    let url = `modalai_docs`;
    return await inboxInstance.get(url, {params});
  },
  updateCustomDoc: async (payload = null, params = null) => {
    let url = `modalai_docs`;
    let headers = {
      'Content-Type': 'multipart/form-data',
      'Authorization': `Bearer ${localStorage.getItem('inbox-chat-token')}`,
    };
    return await inboxInstance.put(url, payload, {params, headers});
  },
  updateCustomDocFields: async (payload = null, params = null) => {
    let url = `modalai_docs`;
    return await inboxInstance.put(url, payload, {params});
  },
  deleteCustomDoc: async (params = null) => {
    let url = `modalai_docs`;
    return await inboxInstance.delete(url, {params});
  },
  getLlmOptions: async (params = null) => {
    let url = `modal_agents?action=llm_options`;
    return await inboxInstance.get(url, {params});
  },
  createCustomDocSetup: async (payload = null, params = null) => {
    let url = `modal_agents`;
    return await inboxInstance.post(url, payload, {params});
  },
  updateCustomDocSetup: async (payload = null, params = null) => {
    let url = `modal_agents`;
    return await inboxInstance.put(url, payload, {params});
  },
  deleteCustomDocSetup: async (params = null) => {
    let url = `modal_agents`;
    return await inboxInstance.delete(url, {params});
  },
  ListCustomDocSetup: async (params = null) => {
    let url = `modal_agents`;
    return await inboxInstance.get(url, {params});
  },
  getCustomDocSetupById: async (params = null) => {
    let url = `modal_agents`;
    return await inboxInstance.get(url, {params});
  },
  getTranslationsAndPlaceholders: async (params = null) => {
    let url = `modal_agents`;
    return await inboxInstance.get(url, {params});
  },
  getManagedModelOptions: async () => {
    return await inboxInstance.get(`modal_agents`, { params: { action: 'managed_model_options' } });
  },
  getManagedSpendingCaps: async () => {
    return await inboxInstance.get(`modal_agents`, { params: { action: 'managed_spending_caps' } });
  },
  setManagedSpendingCap: async (payload) => {
    return await inboxInstance.put(`modal_agents`, payload, { params: { action: 'managed_spending_caps' } });
  },
  promoteModalAgent: async (id) => {
    return await inboxInstance.put(`modal_agents`, {}, { params: { id, action: 'promote' } });
  },
  getModalAgentVersions: async (id) => {
    return await inboxInstance.get(`modal_agents`, { params: { id, action: 'versions' } });
  },
  listManagedAgentSkills: async (params = null) => {
    return await inboxInstance.get(`managed_agent_skills`, { params });
  },
  getManagedAgentSkill: async (skill_ref) => {
    return await inboxInstance.get(`managed_agent_skills`, { params: { skill_ref } });
  },
  createManagedAgentSkill: async (payload) => {
    return await inboxInstance.post(`managed_agent_skills`, payload);
  },
  updateManagedAgentSkill: async (skill_ref, payload) => {
    return await inboxInstance.put(`managed_agent_skills`, payload, { params: { skill_ref } });
  },
  promoteManagedAgentSkill: async (skill_ref) => {
    return await inboxInstance.put(`managed_agent_skills`, {}, { params: { skill_ref, action: 'promote' } });
  },
  getManagedAgentSkillVersions: async (skill_ref) => {
    return await inboxInstance.get(`managed_agent_skills`, { params: { skill_ref, action: 'versions' } });
  },
  deleteManagedAgentSkill: async (skill_ref) => {
    return await inboxInstance.delete(`managed_agent_skills`, { params: { skill_ref } });
  },
  getManagedAgentGlobalPrompt: async () => {
    return await inboxInstance.get(`managed_agent_global_prompt`);
  },
  saveManagedAgentGlobalPrompt: async (payload) => {
    return await inboxInstance.put(`managed_agent_global_prompt`, payload);
  },
  promoteManagedAgentGlobalPrompt: async () => {
    return await inboxInstance.put(`managed_agent_global_prompt`, {}, { params: { action: 'promote' } });
  },
  getManagedAgentGlobalPromptVersions: async () => {
    return await inboxInstance.get(`managed_agent_global_prompt`, { params: { action: 'versions' } });
  },

  getOnboardingReport: async (ref_key = null) => {
    const url = `modal_at`;
    const params = { action: 'report', name: 'onboarding_report' };
    if (ref_key != null && ref_key !== '') params.ref_key = ref_key;
    return await inboxInstance.get(url, { params });
  },

  getRequestInfo: async (params = null) => {
    let url = `runtime_agents`;
    return await agentInstance.get(url, {params});
  },

  listFailedQueries: async (params = null) => {
    let url = `kg`;
    return await agentInstance.get(url, {params});
  },
  UpdateFailedQueries: async (payload = null, params = null) => {
    let url = `kg`;
    return await agentInstance.patch(url, payload, {params});
  },
  getSopHistory: async (params = null) => {
    let url = `content-history/versions`;
    return await activityInstance.get(url, {params});
  },
  getSopHistoryDetail: async (params = null) => {
    let url = `content-history/versions/detail`;
    return await activityInstance.get(url, {params});
  },

  getAgentCopilot: async (params = null) => {
    let url = `agent_copilot`;
    return await inboxInstance.get(url, {params});
  },
  createBinding: async (payload = null, params = null) => {
    let url = `agent_copilot`;
    return await inboxInstance.post(url, payload, {params});
  },
  deleteBinding: async (payload = null, params = null) => {
    let url = `agent_copilot`;
    return await inboxInstance.delete(url, {data: payload, params});
  },
  updateBinding: async (payload = null, params = null) => {
    let url = `agent_copilot`;
    return await inboxInstance.put(url, payload, {params});
  },
  sendeditorAiAgentRequest: async (payload = null, params = null) => {
    let url = `editor_ai`;
    return await inboxInstance.post(url, payload, {params});
  },
  getQuickPrompts: async (params = null) => {
    let url = `quick_prompts`;
    return await inboxInstance.get(url, {params});
  },
  updateQuickPrompts: async (payload = null, params = null) => {
    let url = `quick_prompts`;
    return await inboxInstance.put(url, payload, {params});
  },
  createQuickPrompt: async (payload = null, params = null) => {
    let url = `quick_prompts`;
    return await inboxInstance.post(url, payload, {params});
  },
  updatePromptAction: async (payload = null, params = null) => {
    let url = `quick_prompts`;
    return await inboxInstance.patch(url, payload, {params});
  },
  deleteQuickPrompt: async (params = null) => {
    let url = `quick_prompts`;
    return await inboxInstance.delete(url, {params});
  },

  getAiTaskTemplates: async (params = null) => {
    let url = `ai_task_templates`;
    return await inboxInstance.get(url, {params});
  },
  validateAiTaskTemplate: async (payload = null) => {
    let url = `ai_task_templates`;
    return await inboxInstance.post(url, payload, {params: {validate: 1}});
  },
  createAiTaskTemplate: async (payload = null) => {
    let url = `ai_task_templates`;
    return await inboxInstance.post(url, payload);
  },
  updateAiTaskTemplate: async (payload = null, params = null) => {
    let url = `ai_task_templates`;
    return await inboxInstance.put(url, payload, {params});
  },
  archiveAiTaskTemplate: async (params = null) => {
    let url = `ai_task_templates`;
    return await inboxInstance.delete(url, {params});
  },
  getAiTasks: async (params = null) => {
    let url = `ai_tasks`;
    return await inboxInstance.get(url, {params});
  },

  listAgentQueryPresets: async (params = null) => {
    let url = `agent_query_presets`;
    return await inboxInstance.get(url, {params});
  },
  getAgentQueryPreset: async (params = null) => {
    let url = `agent_query_presets`;
    return await inboxInstance.get(url, {params});
  },
  createAgentQueryPreset: async (payload = null, params = null) => {
    let url = `agent_query_presets`;
    return await inboxInstance.post(url, payload, {params});
  },
  updateAgentQueryPreset: async (payload = null, params = null) => {
    let url = `agent_query_presets`;
    return await inboxInstance.put(url, payload, {params});
  },
  deleteAgentQueryPreset: async (payload = null, params = null) => {
    let url = `agent_query_presets`;
    return await inboxInstance.delete(url, {data: payload, params});
  },
  patchAgentQueryPreset: async (payload = null, params = null) => {
    let url = `agent_query_presets`;
    return await inboxInstance.patch(url, payload, {params});
  },
  getEngagements: async (params = null) => {
    let url = 'engagement_campaigns'
    return await inboxInstance.get(url, {params});
  },
  getEngagementStats: async (params = {}) => {
    let url = 'engagement_campaigns';
    return await inboxInstance.get(url, { params: { view: 'stats', ...params } });
  },
  updateEngagement: async (payload = null, params = null) => {
    let url = 'engagement_campaigns';
    return await inboxInstance.put(url, payload, {params});
  },
  createEngagement: async (payload = null, params = null) => {
    let url = 'engagement_campaigns';
    return await inboxInstance.post(url, payload, {params});
  },
  deleteEngagement: async (payload = null, params = null) => {
    let url = 'engagement_campaigns';
    return await inboxInstance.delete(url, {data: payload, params});
  },
  setEngagementStatus: async (payload = null, params = null) => {
    let url = 'engagement_campaigns';
    return await inboxInstance.patch(url, payload, {params});
  },
  getUpscopeVideoUrl: async (params = null, config = {}) => {
    let url = 'upscope_recording';
    return await inboxInstance.get(url, { params, ...config });
  },
  createAiAutomation: async (payload = null, params = null) => {
    let url = `workflows`;
    return await aiWorkflowsInstance.post(url, payload, {
      params,
      headers: { Prefer: 'respond-async' },
    });
  },
  // Resumes a generation that paused on a clarification question.
  clarifyAiAutomation: async (payload = null, params = null, session_id = null) => {
    let url = `workflows/sessions/${session_id}/clarify`;
    return await aiWorkflowsInstance.post(url, payload, {
      params,
      headers: { Prefer: 'respond-async' },
    });
  },
  getAiWorkflowJob: async (jobId) => {
    return await aiWorkflowsInstance.get(`workflows/jobs/${jobId}`);
  },

  retryEmail:async (payload = null, params = null) => {
    let url = `retry-email`;
    return await integrationsInstance.post(url, payload, {params});
  }
};

export default Api;
